/**
 * Singleton API client for Wishlist module
 *
 * Centralizes all API calls with proper typing.
 * Uses Infrastructure's request helper.
 */

import { request } from '../../../Infrastructure'
import { getCustomerWishlist, addProductsToWishlist, removeProductsFromWishlist } from '../queries'

import type { GraphQLResponse, WishlistItemInput } from '../types'

// Type alias for the full customer wishlist response shape
export type CustomerWishlistResponse = GraphQLResponse['data']

/**
 * Wishlist API client
 *
 * Note: request<T>() returns Promise<{ data: T }>, so we unwrap to return T directly
 */
export const wishlistApi = {
  /**
   * Fetch customer wishlist
   */
  getCustomerWishlist: async (): Promise<CustomerWishlistResponse> => {
    const response = await request<CustomerWishlistResponse>(getCustomerWishlist)
    return response.data
  },

  /**
   * Add products to wishlist
   */
  addProducts: async (wishlistId: string, items: WishlistItemInput[]): Promise<GraphQLResponse> => {
    const response = await request<GraphQLResponse>(addProductsToWishlist, {
      wishlistId,
      wishlistItems: items,
    })
    return response.data
  },

  /**
   * Remove products from wishlist
   */
  removeProducts: async (wishlistId: string, itemIds: string[]): Promise<GraphQLResponse> => {
    const response = await request<GraphQLResponse>(removeProductsFromWishlist, {
      wishlistId,
      wishlistItemsIds: itemIds,
    })
    return response.data
  },
}
